export const CalculatorHyperData = [
    {
        title : "HyperVault Price",
        value : "$0.201145"
    },
    {
        title : "APY:",
        value : "617,122.283%"
    },
    {
        title : "Your HyperVault Balance",
        value : "10,000"
    },
   
]
export const CalculatorAmountData = [
    {
        title:"HyperVault Amount",
        value : "0",
        position : "Max"
    },
    {
        title:"APY (%)",
        value : "617,122.283",
        position : "Current"
    },
    {
        title:"HyperVault price at purchase ($)",
        value : "0.201145",
        position : "Current"
    },
    {
        title:"Future HyperVault PRICE ($)",
        value : "0.201145",
        position : "Current"
    },
]

export const CalculatorTitanoPriceData =[
    {
        title: "Your initial investment",
        value : "$0.00"
    },
    {
        title: "Current wealth",
        value : "$0.00"
    },
    {
        title: "HyperVault rewards estimation",
        value : "0.00 HyperVault"
    },
    {
        title: "Potential return",
        value : "$0.00"
    },
]